import { update } from 'lodash';
import { apiSlice } from '../../api/apiSlice';
import { method } from 'lodash';

export const assignmentRetakeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRetakeResult: builder.mutation({
      query: (options) => ({
        url: `AssignmentRetake/assignment/${options.assignmentId}/Student/${options.studentId}/RetakeResult`,
        method: 'GET'
      })
    }),
    getSessionDates: builder.mutation({
      query: (options) => ({
        url: `AssignmentRetake/assignment/${options.assignmentId}/student/${options.studentId}/SessionDates`,
        method: 'GET'
      })
    }),
    updateSessionDates: builder.mutation({
      query: (options) => ({
        url: `AssignmentRetake/assignment/${options.assignmentId}/student/${options.studentId}/SessionDates`,
        method: 'PUT',
        body: {
          startDate: options.startDate,
          endDate: options.endDate
        }
      })
    }),
    unassignRetake: builder.mutation({
      query: (options) => ({
        url: `AssignmentRetake/assignment/${options.assignmentId}/student/${options.studentId}/UnassignRetake`,
        method: 'POST'
      })
    }),
    triggerManualRetake: builder.mutation({
      query: (options) => ({
        url: `AssignmentRetake/assignment/${options.assignmentId}/student/${options.studentId}/manuallyAssign`,
        method: 'POST'
      })
    })
  })
});

export const {
  useGetRetakeResultMutation,
  useGetSessionDatesMutation,
  useUpdateSessionDatesMutation,
  useUnassignRetakeMutation,
  useCheckCanManuallyAssignMutation,
  useTriggerManualRetakeMutation
} = assignmentRetakeApi;